import { createAction } from 'typesafe-actions'

export const setAuthToken = createAction('SET_AUTH_TOKEN')<string>()
export const unsetAuthToken = createAction('UNSET_AUTH_TOKEN')<void>()
